module.exports = __webpack_public_path__ + "15d27f3c888e1057a19d91d2cede37c6.pdf";